/**
 * Client-side quick find for index tables (Whitegloves, Medicare Advantage, etc.).
 * Hides non-matching rows; case-insensitive match on a row `data-*` string or `textContent`.
 */
function filterTableRows (input, tableId, rowDataAttr) {
  const table = document.getElementById(tableId)
  if (!table) return
  const tbody = table.querySelector('tbody')
  if (!tbody) return
  const q = (input.value || '').trim().toLowerCase()
  const rows = tbody.getElementsByTagName('tr')
  for (let i = 0; i < rows.length; i++) {
    const tr = rows[i]
    const text = (tr.getAttribute(rowDataAttr) || tr.textContent || '').toLowerCase()
    const show = !q || text.indexOf(q) !== -1
    if (show) {
      tr.removeAttribute('hidden')
    } else {
      tr.setAttribute('hidden', '')
    }
  }
}

const INDEX_TABLE_QUICK_SEARCH = [
  { inputAttr: 'data-whiteglove-table-search', tableId: 'whitegloves-index-table', rowDataAttr: 'data-whiteglove-search' },
  { inputAttr: 'data-medicare-advantage-table-search', tableId: 'medicare-advantage-providers-index-table', rowDataAttr: 'data-medicare-advantage-search' }
]

let delegated = false
export function initWhitegloveIndexTable () {
  if (delegated) return
  delegated = true
  document.addEventListener('input', (e) => {
    const t = e.target
    if (!t || t.tagName !== 'INPUT' || !t.hasAttribute) return
    for (const { inputAttr, tableId, rowDataAttr } of INDEX_TABLE_QUICK_SEARCH) {
      if (t.hasAttribute(inputAttr)) {
        filterTableRows(/** @type {HTMLInputElement} */ (t), tableId, rowDataAttr)
        return
      }
    }
  })
}
